const helper = {
    /**
     * Laravel validation error 메시지 객체에서 특정 에러 메시지만 검색.
     * @param errors Object
     * @param key String
     * @returns {null|String}
     */
    retrieveFormError(errors, key) {
        if (errors && errors[key] && errors[key].length > 0) {
            return errors[key][0];
        }

        return null;
    },

    retrieveAllFormError(errors) {
        const formErrors = {};

        Object.keys(errors).forEach(value => {
            formErrors[value] = this.retrieveFormError(errors, value);
        });

        return formErrors;
    },

    /**
     * axios 에러 처리.
     * @param vue
     * @param error
     * @param passStatuses 에러 처리를 하지 않을 상태 코드 목록.
     * @return {null|Number}
     */
    axiosCatchError(vue, error, passStatuses = []) {
        if (error.response) {
            if (!passStatuses.includes(error.response.status)) {
                // csrf 토큰이 만료됐거나 없는 경우.
                if (error.response.status === 419) {
                    alert("보안 토큰이 만료되었습니다.");
                } else if (error.response.status === 401) {
                    alert("인증이 만료되었습니다.");
                } else if (error.response.status === 403) {
                    alert("권한이 없습니다.");
                } else {
                    alert(error.response.data?.message || "에러가 발생하였습니다.");
                }
            }

            return error.response.status;
        } else if (error.request) {
            alert("통신 중 장애가 발생하였습니다.");
        } else {
            alert("오류가 발생하였습니다.");
        }

        return null;
    },

    /**
     * 폼 전송시 사용할 헤더.
     * @returns {{Accept: string, "Content-Type": string}}
     */
    axiosPostHeaders() {
        return {
            "Content-Type": "application/json",
            Accept: "application/json",
        };
    },

    /**
     * http 전송시 사용할 헤더.
     * @returns {{Accept: string}}
     */
    axiosGetHeaders() {
        return {
            Accept: "application/json",
        };
    },

    /**
     * number format
     * @param num
     * @returns {string}
     */
    numberFormat(num) {
        const number = Number(num);

        if (Number.isNaN(number)) {
            return '0';
        }

        return number.toLocaleString();
    },

    removeEmojis(val) {
        const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|\ufe0f)/g;
        return val.replace(regex, '');
    },

    /**
     * 쿠키값 설정.
     * @param name
     * @param value
     * @param days
     */
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    /**
     * 쿠키값 가져오기.
     * @param name
     * @returns {string|null}
     */
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    openPopup(url, width, height, top, left, name)  {
        let screenWidth = screen.availWidth;

        if (!name) name = "popup-" + Math.floor(Math.random() * 1000000);
        if (!width) width = 800;
        if (!height) height = 600;
        if (!top) top = 100;
        if (!left) left = (screenWidth - width) / 2;

        return window.open(url, name, "scrollbars=1,resizable=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
    }
};

export default helper;
